module.exports = __webpack_public_path__ + "img/2.5.edc1ea16.png";